import { render, staticRenderFns } from "./TheFooterDynamic.vue?vue&type=template&id=3764d0e6"
import script from "./TheFooterDynamic.vue?vue&type=script&lang=ts"
export * from "./TheFooterDynamic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports